export default {"src":"/_next/static/media/history.a63b09aa.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};